import { NgClass } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NgFooterTemplateDirective,
  NgOptionComponent,
  NgSelectComponent,
} from '@ng-select/ng-select';

import { EditableListDropdownItem } from '@shared/components/editable-list-dropdown/editable-list-dropdown-item.model';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import { ForecastTableGridMethodChange } from '../../models/forecast-table-grid.model';

@Component({
  imports: [
    NgSelectComponent,
    TooltipDirective,
    NgClass,
    FormsModule,
    NgOptionComponent,
    NgFooterTemplateDirective,
    IconComponent,
  ],
  selector: 'aux-forecast-table-grid-method-patient',
  styleUrls: ['./forecast-table-grid-method-patient.component.scss'],
  templateUrl: './forecast-table-grid-method-patient.component.html',
})
export class ForecastTableGridMethodPatientComponent {
  @Input() categoryId = '';
  @Input() disabled = false;
  dropdownOpen = false;
  @ViewChild('gridMethodPatient') public input!: NgSelectComponent;
  @Input() isChild = false;
  @Input() isInvalid = false;
  @Input() onMethodChange!: ForecastTableGridMethodChange;
  @Input() patientCurves: EditableListDropdownItem[] = [];
  @Input() placeholder = '';
  @Input() primarySettingsId = '';
  @Input() selectedPatientCurve = '';
  @Input() tooltip = '';

  onDropdownClose() {
    this.dropdownOpen = false;
  }

  onDropdownOpen() {
    this.dropdownOpen = true;
  }

  select(event: string): void {
    this.onMethodChange(event, this.primarySettingsId, {
      id: this.categoryId,
      name: !this.isChild ? 'category' : 'activity',
      prop: 'driver_setting',
    });
  }
}
